export const enumServerManagement = {
  None: 0,
  Standard: 1,
  Enterprise: 2,
  Basis: 3,
  Database: 4
};
